import Support from "../assets/support.gif"
import Savings from "../assets/savings.gif"
import Consult from "../assets/consult.gif"
import Hastle from "../assets/hastle.gif"
import Performance from "../assets/performance.gif"
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { useEffect } from "react"
import AOS from 'aos';
import 'aos/dist/aos.css';

const NonProfit = () => {
    useEffect(() => {
        AOS.init();    
    }, []);
    return (
        <div>
            <Helmet>
                <title>Rave Energy | Non-Profit</title>
                <meta name="keywords" content="HTML,CSS,JavaScript" />
                <meta
                    name="description"
                    content="Rave Energy non-profit energy provider"
                />
            </Helmet>
            <main style={{ color : `#2C3E50` }}>
                <div className="h-56 sm:h-40 md:h-40 lg:h-40 xl:h-40" style={{ background: `#00102f`}}>
                    <h1 className="font-bold text-center tracking-tighter text-4xl md:text-4xl lg:text-5xl pt-24 sm:pt-24 md:pt-24 lg:pt-12 xl:pt-12 text-white">Non-Profit</h1>
                </div>
                <div className="flex flex-col items-center sm:px-4 md:px-0 lg:px-4 mt-8">
                    <h1 className="font-medium tracking-tighter sm:text-6xl text-4xl mt-0 sm:mt-6 md:mt-6 lg:mt-6 xl:mt-6 text-center">Powering Your <span className="text-red-500"> True Purpose</span></h1>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0 mt-6">As a non-profit, your ability to change the world is often limited by your budget. When operational costs are high, expanding your non-profit’s reach and fulfilling your purpose becomes more difficult.</p>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0">With our technology, you’ll gain access to energy experts, valuable resources, and simple account management tools that make energy procurement easier and more economical than ever before. Combined with our proven experience in helping non-profits achieve their financial and operational goals, we serve as a true energy partner for your organization.</p>
                    <p className="sm:text-justify text-center font-light text-xl max-w-3xl mt-4 px-4 md:px-0 lg:px-0">Through our Reverse Auction, we deliver a simple, straightforward approach to reducing your operational expenses – enabling you to put your time and focus towards building on your mission and vision.</p>
                </div>
                <div>
                    <h1 className="font-medium tracking-tighter text-center sm:text-6xl text-4xl mt-6">What <span className="text-red-500"> We </span> Offer</h1>
                    <div data-aos-ease="ease" data-aos-duration="400" data-aos="fade-up" className="flex flex-col items-center mt-6">
                        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row">
                            <div className="flex flex-col items-center m-0 md:mr-8 lg:mr-8 xl:mr-8">
                                <img className="m-2 w-44 mx-auto antialiased" src={Support} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Ongoing Support</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:mx-8 lg:mx-8 xl:mx-8">
                                <img className="m-2 w-44 mx-auto" src={Savings} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Complimentary Savings Analysis</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:ml-8 lg:ml-8 xl:ml-8">
                                <img className="m-2 w-44 mx-auto" src={Consult} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Complimentary Consultation</h1>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row mt-8">
                            <div className="flex flex-col items-center m-0 md:mr-8 lg:mr-8 xl:mr-8">
                                <img className="m-2 w-44 mx-auto" src={Hastle} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Commitment and Hastle Free</h1>
                            </div>
                            <div className="flex flex-col items-center m-0 md:ml-8 lg:ml-8 xl:ml-8">
                                <img className="m-2 w-44 mx-auto" src={Performance} alt="Demand Response" height="200" width="250" />
                                <h1 className="font-medium text-center text-2xl tracking-tighter">Performance Driven Results</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center py-8">
                    <h1 className="font-medium tracking-tighter text-center sm:text-6xl text-4xl mt-0 sm:mt-6 md:mt-6 lg:mt-6 xl:mt-6">Learn <span className="text-red-500"> More!</span></h1>
                    <Link className="px-8 py-3 bg-red-500 rounded mt-8 text-white text-xl hover:shadow-md transition duration-500" to="/contact">Contact us</Link>
                </div>
            </main>
        </div>
    );
}
 
export default NonProfit;